import React from "react";
import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../../shared_components/basic_react_table_wrapper";

const DISABLE_SORT = "DISABLE_SORT";

class Overview extends React.Component {
  render () {
    const pageSize = this.props.pageSize;
    const totalPages = Math.ceil(this.props.totalResults / pageSize);

    const regulations = this.props.regulations;
    const columnKeysAndHeadings = {
      country: ["Country", "country"],
      region: ["Region", "region"],
      name: ["Document name", "name_raw"],
      yearPassed: ["Year passed", "year_passed"],
      yearUpdated: ["Year updated", "year_updated"],
      applications: ["Applications", DISABLE_SORT],
      targets: ["Target sectors", DISABLE_SORT],
      standards: ["# of Standards", "numerical_standards_count"]
    };

    const tagKeys = ["applications", "targets"];

    const data = regulations.map((e) => {
      return Object.keys(columnKeysAndHeadings).map(key => {
        if (tagKeys.includes(key)) {
          return e[key].map(tag => {
            const name = tag.name;
            const icon = tag.icon;

            let r = name;
            if (icon) {
              r = <img className="tag-icon-image" title={name} data-original-title={name} src={icon} />;
            }

            return <span key={name} style={{ marginRight: "3px" }}>{r}</span>;
          });
        } else if (key === "standards") {
          let r;
          if (e.numericalStandardsCount > 0) {
            r = <a className="btn btn-primary">See {e.numericalStandardsCount}</a>;
          } else {
            r = <a onClick={e => e.stopPropagation()} disabled className="btn btn-primary">None</a>;
          }

          return r;
        } else {
          return e[key];
        }
      });
    });
    const tableData = [
      Object.values(columnKeysAndHeadings).map(e => e[0])
    ].concat(data);

    const reactTableProps = {
      onPageChange: this.props.onPageChange,
      onSortedChange: (reactTableSortedList) => {
        const forServer = reactTableSortedList.map(reactTableSortedProp => {
          const r = {};
          const index = +reactTableSortedProp.id.split("-")[1];
          const key = Object.values(columnKeysAndHeadings)[index][1];

          if (key === DISABLE_SORT) { return { blank: true }; }

          const descOrAsc = reactTableSortedProp.desc ? "desc" : "asc";
          r[key] = descOrAsc;
          return r;
        }).filter(f => !f.blank);

        const wrapped = {
          forServer,
          reactTableSortedList
        };

        this.props.onSortedChange(wrapped);

        return false;
      },
      manual: true,
      defaultPageSize: pageSize,
      pages: totalPages,
      page: this.props.page,
      sorted: (this.props.sorted || {}).reactTableSortedList,
      getTrGroupProps: (state, rowInfo, column) => {
        if (!rowInfo) { return {}; }
        column;

        const focusRegulationOnClick = this.props.regulationDetailClick([this.props.regulations[rowInfo.index]]);

        return {
          style: {
            cursor: "pointer"
          },
          onClick: focusRegulationOnClick
        };
      }
    };


    return (
      <div className="overview">
        <BasicReactTableWrapper
          data={tableData}
          minWidths={[50, 40, 200, 30, 30, 100, 100]}
          unsortableColumns={[5, 6]}
          labelColumnIndex={() => true}
          reactTableProps={reactTableProps}
          addHighlightClass={true}
        />
      </div>
    );
  }
}

Overview.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  onSortedChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  sorted: PropTypes.shape({
    reactTableSortedList: PropTypes.array.isRequired
  }),
  totalResults: PropTypes.number.isRequired,
  regulations: PropTypes.array.isRequired,
  regulationDetailClick: PropTypes.func.isRequired,
};

export default Overview;
